import { Link } from '@/navigation';
import React from 'react';

const NotFound = () => {
  return (
    <div className="grid h-[100vh] place-content-center bg-white px-4">
      <div className="h-auto text-center">
        <h1 className="text-9xl font-black text-charcoal-v2">404</h1>
        <p className="text-2xl font-bold tracking-tight text-charcoal-v2 sm:text-4xl">
          Oh no!
        </p>
        <div className="m-4 text-gray-500">We can't find that page.</div>
        <div className="relative">
          <Link href="/" className="btn-responsive btn-primary btn">
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default React.memo(NotFound);
